import { TRACKERS } from "@/constants/Trackers";
import { SocialHistory } from "@/features/Patient/MedicalRecords/SocialHistory/SocialHistory";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/social-history")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_SOCIAL_HISTORY);
  },
});

function RouteComponent() {
  return <SocialHistory />;
}
